<p mat-dialog-title>
  {{ modalData.text }}
</p>

<div mat-dialog-actions>
  <app-button class="modal-button" [text]="approveText" [color]="primaryColor" (OnClick)="closeModal()"></app-button>
</div>
